import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CancelBackgroundJobMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type CancelBackgroundJobMutation = { __typename?: 'Mutation', cancelBackgroundJob: { __typename?: 'BackgroundJobPayload', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type RetryFailedBackgroundJobItemsMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type RetryFailedBackgroundJobItemsMutation = { __typename?: 'Mutation', retryFailedBackgroundJobItems: { __typename?: 'BackgroundJobPayload', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type DismissBackgroundJobMutationVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  type?: Types.InputMaybe<Types.BackgroundJobType>;
}>;


export type DismissBackgroundJobMutation = { __typename?: 'Mutation', dismissBackgroundJob: { __typename?: 'BackgroundJobPayload', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type ClearFinishedBackgroundJobsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ClearFinishedBackgroundJobsMutation = { __typename?: 'Mutation', clearFinishedBackgroundJobs: { __typename?: 'ClearFinishedBackgroundJobsPayload', count: number, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };


export const CancelBackgroundJobDocument = new TypedDocumentString(`
    mutation CancelBackgroundJob($jobId: String!) {
  cancelBackgroundJob(jobId: $jobId) {
    backgroundJob {
      ...BackgroundJobFields
    }
    errors {
      message
    }
  }
}
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}`);
export const RetryFailedBackgroundJobItemsDocument = new TypedDocumentString(`
    mutation RetryFailedBackgroundJobItems($jobId: String!) {
  retryFailedBackgroundJobItems(jobId: $jobId) {
    backgroundJob {
      ...BackgroundJobFields
    }
    errors {
      message
    }
  }
}
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}`);
export const DismissBackgroundJobDocument = new TypedDocumentString(`
    mutation DismissBackgroundJob($jobId: String!, $type: BackgroundJobType) {
  dismissBackgroundJob(jobId: $jobId, type: $type) {
    backgroundJob {
      ...BackgroundJobFields
    }
    errors {
      message
    }
  }
}
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}`);
export const ClearFinishedBackgroundJobsDocument = new TypedDocumentString(`
    mutation ClearFinishedBackgroundJobs {
  clearFinishedBackgroundJobs {
    count
    errors {
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CancelBackgroundJob: build.mutation<CancelBackgroundJobMutation, CancelBackgroundJobMutationVariables>({
      query: (variables) => ({ document: CancelBackgroundJobDocument, variables })
    }),
    RetryFailedBackgroundJobItems: build.mutation<RetryFailedBackgroundJobItemsMutation, RetryFailedBackgroundJobItemsMutationVariables>({
      query: (variables) => ({ document: RetryFailedBackgroundJobItemsDocument, variables })
    }),
    DismissBackgroundJob: build.mutation<DismissBackgroundJobMutation, DismissBackgroundJobMutationVariables>({
      query: (variables) => ({ document: DismissBackgroundJobDocument, variables })
    }),
    ClearFinishedBackgroundJobs: build.mutation<ClearFinishedBackgroundJobsMutation, ClearFinishedBackgroundJobsMutationVariables | void>({
      query: (variables) => ({ document: ClearFinishedBackgroundJobsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCancelBackgroundJobMutation, useRetryFailedBackgroundJobItemsMutation, useDismissBackgroundJobMutation, useClearFinishedBackgroundJobsMutation } = injectedRtkApi;
